import React, { useState } from 'react';
import { usePWAInstall } from '../hooks/usePWAInstall';
import { Download } from 'lucide-react';

interface PWAInstallButtonProps {
  /** コンパクト表示（アイコンのみ等） */
  compact?: boolean;
  /** 暗い背景用（テキストを白系に） */
  dark?: boolean;
  className?: string;
}

const TIP_TEXT = 'ホーム画面にショートカットを追加すると便利です。ブラウザのメニューもしくはアドレスバー横のボタンから追加できます。';

export const PWAInstallButton: React.FC<PWAInstallButtonProps> = ({ compact = false, dark = false, className = '' }) => {
  const { isInstalled, canInstall, promptInstall } = usePWAInstall();
  const [loading, setLoading] = useState(false);
  const [showInstructions, setShowInstructions] = useState(false);

  if (isInstalled) return null;

  const handleClick = async () => {
    if (canInstall) {
      setLoading(true);
      try {
        await promptInstall();
      } finally {
        setLoading(false);
      }
    } else {
      setShowInstructions((prev) => !prev);
    }
  };

  const btnCls = dark
    ? 'p-2 rounded-lg text-gray-300 hover:bg-gray-300/30 transition-colors'
    : 'p-2 rounded-lg text-gray-600 bg-[#FFF] hover:bg-teal-100 transition-colors';

  const instructionCls = 'text-sm text-gray-500 text-left md:text-xs md:text-center md:text-[#000] md:leading-relaxed';
  const instructionWrapperCls = 'max-w-[260px] md:max-w-[480px] px-4 mt-2 md:mt-3 w-full';

  return (
    <div className={`${className} flex flex-col items-center`}>
      <button
        type="button"
        onClick={handleClick}
        disabled={loading}
        className={btnCls}
        aria-label={canInstall ? 'ホーム画面に追加' : 'ホーム画面に追加の方法を表示'}
      >
        <Download size={20} />
      </button>
      {showInstructions && !canInstall && (
        <div className={`${instructionWrapperCls}`}>
          <p className={instructionCls}>
            <span className="md:hidden">{TIP_TEXT}</span>
            <span className="hidden md:block">
              ホーム画面にショートカットを追加すると便利です。
              <br />
              ブラウザのメニューもしくはアドレスバー横のボタンから追加できます。
            </span>
          </p>
        </div>
      )}
    </div>
  );
};
